import type { Report } from './GeneralLedgerExportButton';

export const REPORT_TITLES: Record<Report, string> = {
  'trial-balance': 'Trial Balance',
  'trust-reconciliation': 'Trust Reconciliation',
  'trust-reconciliation-by-listing': 'Trust Reconciliation by Listing',
  'guest-balances': 'Guest Balances',
  'sales-tax-liability': 'Reservation Lodging & Occupancy Tax Report',
  'profit-and-loss': 'Profit and Loss',
  'balance-sheet': 'Balance Sheet',
  detail: 'General Ledger',
  'statement-summaries': 'Owner Statement Summaries',
};
